import * as React from "react";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";

import MyTabbedLayout from "../mui/TabbedLayout";

import BasicSettings from "./Fee";
import Information from "./Information";

import ReportView from "./reportView";
import { loadAllSettings, sendPushNotification } from "../data/API";
import AlertDialog from "../mui/dialog";
import ProgressDialog from "../mui/progressdialog";
import Holidays from "./Holidays";

export const TITLE_HOME = "Settings";
export const TITLE_INFORMATION = TITLE_HOME + " > Information";
export const TITLE_FEES = TITLE_HOME + " > Fees & Taxes";
export const TITLE_HOLIDAYS = TITLE_HOME + " > Holidays";

export const TITLE_REPORT_DETAILS = TITLE_HOLIDAYS + " > Report Details";

export default function Settings() {
  const [state, setState] = React.useState(TITLE_FEES);

  const [settings, setSettings] = React.useState(null);
  const [selectedReportData, setSelectedAgentData] = React.useState(null);

  const [isWarning, setIsWarning] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const [count, setCount] = React.useState(0);




  function loadData() {
    setIsLoading(true);
    setIsWarning(false);
    if (count === 0) {
      // console.log('called:loadData'+count);
      setCount(count + 1);
      loadAllSettings((err, data) => {

        console.log(data);
        if (err) {
          setIsWarning(true);
          setIsLoading(false);
          console.log(err);
        } else {
          setSettings(data);
          setIsLoading(false);
          setIsWarning(false);
        }
      });
    }
  }

  React.useEffect(() => {
    loadData();
  }, []);

  function onReportSelection(data) {
    setSelectedAgentData(data);
    setState(TITLE_REPORT_DETAILS);
  }
  const onBackClickListener = () => {
    if (state === TITLE_REPORT_DETAILS) {
      setState(TITLE_HOLIDAYS);
    }
  };

  return (
    <div>
      <ProgressDialog msg={"Loading Settings"} visible={isLoading} />
      <AlertDialog
        warningMessage={
          "Something went wrong! please refresh page or connect with internet"
        }
        visible={isWarning}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginBlockEnd: "16px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            padding: 8,
            background: "red",
            display: "inline-flex",
            flexDirection: "row",
            borderRadius: "10px",
            boxShadow: "1px 1px 5px 2px rgb(0,0,0,0.2)",
          }}
        >
          <HomeIcon
            onClick={() => {
              if (state !== TITLE_FEES && state !== TITLE_INFORMATION)
                setState(TITLE_FEES);
            }}
            sx={{
              color: "white",
              alignSelf: "center",
              marginInlineEnd: 1,
            }}
          />
          {state !== TITLE_FEES &&
          state !== TITLE_INFORMATION &&
          state !== TITLE_HOLIDAYS ? (
            <ArrowBackIosIcon
              onClick={onBackClickListener}
              sx={{
                color: "white",
                alignSelf: "center",
                marginInlineEnd: 1,
                marginInlineStart: 1,
              }}
            />
          ) : (
            ""
          )}
          <h1
            style={{
              color: "rgb(255, 255, 255)",
              fontSize: 20,
            }}
          >
            {state}
          </h1>
        </div>
      </div>
      <div     style={{
        height:window.innerHeight-100,
        overflow:'auto'
      }}>
        {state === TITLE_FEES ||
        state === TITLE_INFORMATION ||
        state === TITLE_HOLIDAYS ? (
          <MyTabbedLayout
            defaultSelection={
              state === TITLE_FEES ? 0 : state === TITLE_INFORMATION ? 1 : 2
            }
            onSelection={(value) => {
              if (value === 0) setState(TITLE_FEES);
              else if (value === 1) setState(TITLE_INFORMATION);
              else setState(TITLE_HOLIDAYS);
            }}
            tabs={[
              {
                title: "BASICS",
                element: (
                  <BasicSettings
                    setLoading={setIsLoading}
                    setWarning={setIsWarning}
                    feesAndTaxes={settings?.fees}
                    metaData={settings?.meta_data}
                  />
                ),
              },
              {
                title: "Information",
                element: (
                  <Information
                    setLoading={setIsLoading}
                    setWarning={setIsWarning}
                    data={settings?.information}
                  />
                ),
              },
              {
                title: "Holidays",
                element: (
                  <Holidays
                  setIsLoading={(value)=>{
                    setIsLoading(value);
                    
                  }}
                    holidays={settings?.holidays}
                    
                  />
                ),
              },
            ]}
          />
        ) : (
          <ReportView data={selectedReportData} />
        )}
      </div>
    </div>
  );
}
